import { relations } from "drizzle-orm/_relations";
import {
  boolean,
  index,
  integer,
  pgTable,
  serial,
  unique,
} from "drizzle-orm/pg-core";
import { createSchemaFactory } from "drizzle-zod";
import { z } from "zod";

import { tournamentDivisions } from "./tournament-divisions";
import { tournaments } from "./tournaments";

const { createInsertSchema, createSelectSchema, createUpdateSchema } =
  createSchemaFactory({ zodInstance: z });

export const tournamentInviteSources = pgTable(
  "tournament_invite_sources",
  {
    id: serial().primaryKey(),
    sourceTournamentDivisionId: integer()
      .notNull()
      .references(() => tournamentDivisions.id, { onDelete: "cascade" }),
    targetTournamentId: integer()
      .notNull()
      .references(() => tournaments.id, { onDelete: "cascade" }),
    topN: integer().notNull(),
    processed: boolean().notNull().default(false),
  },
  (table) => [
    unique("tournament_invite_sources_source_target_unique").on(
      table.sourceTournamentDivisionId,
      table.targetTournamentId,
    ),
    index("tournament_invite_sources_target_idx").on(table.targetTournamentId),
  ],
);

export const selectTournamentInviteSourceSchema = createSelectSchema(
  tournamentInviteSources,
);
export const createTournamentInviteSourceSchema = createInsertSchema(
  tournamentInviteSources,
).omit({
  id: true,
});
export const updateTournamentInviteSourceSchema = createUpdateSchema(
  tournamentInviteSources,
);

export type TournamentInviteSource = z.infer<
  typeof selectTournamentInviteSourceSchema
>;
export type CreateTournamentInviteSource = z.infer<
  typeof createTournamentInviteSourceSchema
>;
export type UpdateTournamentInviteSource = z.infer<
  typeof updateTournamentInviteSourceSchema
>;

export const tournamentInviteSourcesRelations = relations(
  tournamentInviteSources,
  ({ one }) => ({
    sourceTournamentDivision: one(tournamentDivisions, {
      fields: [tournamentInviteSources.sourceTournamentDivisionId],
      references: [tournamentDivisions.id],
    }),
    targetTournament: one(tournaments, {
      fields: [tournamentInviteSources.targetTournamentId],
      references: [tournaments.id],
    }),
  }),
);
